import { NavLink as RouterNavLink } from "react-router-dom";
import { cn } from "@/lib/utils";
import { LucideIcon } from "lucide-react";

interface TabItemProps {
  to: string;
  icon: LucideIcon;
  label: string;
  badge?: number;
}

export function TabItem({ to, icon: Icon, label, badge }: TabItemProps) {
  return (
    <RouterNavLink
      to={to}
      className={({ isActive }) =>
        cn(
          "flex flex-col items-center justify-center flex-1 py-2 gap-0.5 transition-colors duration-200 relative",
          isActive ? "text-primary" : "text-muted-foreground hover:text-foreground"
        )
      }
    >
      <div className="relative">
        <Icon className="w-5 h-5" />
        {badge != null && badge > 0 && (
          <span className="absolute -top-1.5 -right-2.5 min-w-[16px] h-4 px-1 rounded-full bg-destructive text-destructive-foreground text-[9px] font-bold flex items-center justify-center">
            {badge > 99 ? "99+" : badge}
          </span>
        )}
      </div>
      <span className="text-[10px] font-medium">{label}</span>
    </RouterNavLink>
  );
}

interface MobileTabBarProps {
  children: React.ReactNode;
}

export function MobileTabBar({ children }: MobileTabBarProps) {
  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-card border-t border-border flex items-center justify-around h-16 px-2 z-50 safe-area-inset-bottom">
      {children}
    </nav>
  );
}
